const state = {
  reminders: {}
}

export default state


